import { useMemo } from 'react';

/**
 * Custom hook for profile/client-related utilities.
 * Provides helper functions and transformed data for profile dropdowns.
 *
 * @param {Array} profiles - Array of profile objects with {clientKey, name} format
 * @returns {Object} Profile utilities
 */
const useProfileUtils = (profiles) => {
  // Transform profiles for dropdown components
  const profileItems = useMemo(() => {
    if (!profiles || !Array.isArray(profiles)) return [];
    return profiles.map(profile => ({
      label: profile.name,
      value: profile.clientKey
    }));
  }, [profiles]);

  // Get profile name from client key
  const getProfileName = (clientKey) => {
    if (!clientKey || !profiles || !Array.isArray(profiles)) {
      return clientKey || '';
    }
    const profile = profiles.find(p => p.clientKey === clientKey);
    return profile ? profile.name : clientKey;
  };

  return {
    profileItems,
    getProfileName
  };
};

export default useProfileUtils;
